import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, mergeMap, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as appStore from '@appstore/*';
import { Page } from '@models/*';
import * as overviewStore from '@overviewstore/*';
import { ToastService } from '../core/services/toast.service';
import { MainRoutes } from '../pages/main-routes.enum';

@Injectable()
export class TourGuard implements CanActivate {
  constructor(
    private toastService: ToastService,
    private store: Store<overviewStore.OverviewState | appStore.AppState>
  ) {}

  canActivate(_: ActivatedRouteSnapshot, __: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(overviewStore.getToursLoaded).pipe(
      filter((isComplete) => isComplete),
      take(1),
      mergeMap(() => this.store.select(overviewStore.getCurrentTour)),
      take(1),
      map((tour) => {
        if (tour) {
          return true;
        } else {
          this.store.dispatch(new appStore.RouterNavigate({ path: [MainRoutes.OLD_DRIVER_APP] }));
          this.toastService.generatePageRedirectToast(Page.TOUR);
          return false;
        }
      })
    );
  }
}
